import { AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { Lexer } from '../services/lexer/lexer.service';
import { Parser } from '../services/parser/parser.service';
import { BBScriptCode } from '../interfaces/bbscript-code';
import { concat } from 'rxjs';
import { GameStateService } from '../services/game-state/game-state.service';
import { BabylonJSService } from '../services/babylon-js/babylon-js.service';
import { Graphics2dService } from '../services/2d/graphics2d.service';
import { GuiService } from '../services/gui/gui.service';
import { LanguageService } from '../services/language/language.service';

@Component({
  selector: 'blitz-basic-script-canvas',
  templateUrl: 'blitz-basic-script.html',
  styleUrls: ['blitz-basic-script.scss']
})
export class BlitzBasicScriptComponent implements OnInit, AfterViewInit {
  @Input() code: string[][];
  @Input() debug?: boolean;

  @ViewChild('canvas2d', { static: false }) canvas2d: ElementRef;
  @ViewChild('canvas3d', { static: false }) canvas3d: ElementRef;
  public canvasFocused: boolean;

  /** Key code conversion schema **/
  private readonly keyCodes = {
    Escape: 1,
    Digit1: 2,
    Digit2: 3,
    Digit3: 4,
    Digit4: 5,
    Digit5: 6,
    Digit6: 7,
    Digit7: 8,
    Digit8: 9,
    Digit9: 10,
    Digit0: 11,
    Minus: 12,
    Equal: 13,
    Backspace: 14,
    Tab: 15,
    KeyQ: 16,
    KeyW: 17,
    KeyE: 18,
    KeyR: 19,
    KeyT: 20,
    KeyY: 21,
    KeyU: 22,
    KeyI: 23,
    KeyO: 24,
    KeyP: 25,
    BracketLeft: 26,
    BracketRight: 27,
    Enter: 28,
    ControlLeft: 29,
    KeyA: 30,
    KeyS: 31,
    KeyD: 32,
    KeyF: 33,
    KeyG: 34,
    KeyH: 35,
    KeyJ: 36,
    KeyK: 37,
    KeyL: 38,
    Semicolon: 39,
    Quote: 40,
    Backquote: 41,
    ShiftLeft: 42,
    Backslash: 43,
    KeyZ: 44,
    KeyX: 45,
    KeyC: 46,
    KeyV: 47,
    KeyB: 48,
    KeyN: 49,
    KeyM: 50,
    Comma: 51,
    Period: 52,
    Slash: 53,
    ShiftRight: 54,
    Multiply: 55,
    AltLeft: 56,
    Space: 57,
    CapsLock: 58,
    F1: 59,
    F2: 60,
    F3: 61,
    F4: 62,
    F5: 63,
    F6: 64,
    F7: 65,
    F8: 66,
    F9: 67,
    F10: 68,
    NumLock: 69,
    ScrollLock: 70,
    NumPad7: 71,
    NumPad8: 72,
    NumPad9: 73,
    // Minus: 74,
    NumPad4: 75,
    NumPad5: 76,
    NumPad6: 77,
    Plus: 78,
    NumPad1: 79,
    NumPad2: 80,
    NumPad3: 81,
    NumPad0: 82,
    // Comma: 83,
    IntlBackslash: 86,
    F11: 87,
    F12: 88,
    TODO: 153,
    ControlRight: 157,
    AltRight: 184,
    ArrowUp: 200,
    ArrowLeft: 203,
    ArrowRight: 205,
    ArrowDown: 208
  };

  private readonly mouseCodes = {
    0: 1,
    1: 3,
    2: 2
  };

  @HostListener('window:keydown', ['$event'])
  keyDownEvent(event: KeyboardEvent) {
    // console.log(event);
    this.gameState.setKeyDown(this.keyCodes[event.code], true);
    this.gameState.setKeyAsciiCode(event.key.charCodeAt(0));
  }

  @HostListener('window:keyup', ['$event'])
  keyUpEvent(event: KeyboardEvent) {
    this.gameState.incrementKeyHit(this.keyCodes[event.code]);
  }

  @HostListener('window:mousedown', ['$event'])
  mouseDownEvent(event: MouseEvent) {
    this.gameState.setMouseDown(this.mouseCodes[event.button], true);
  }

  @HostListener('window:mouseup', ['$event'])
  mouseUpEvent(event: MouseEvent) {
    this.gameState.incrementMouseHit(this.mouseCodes[event.button]);
  }

  constructor(private language: LanguageService,
    private lexer: Lexer,
    private parser: Parser,
    private gameState: GameStateService,
    private babylonjs: BabylonJSService,
    private graphics2d: Graphics2dService,
    private gui: GuiService
  ) {
    this.canvasFocused = false;
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {

  }

  executeCode(code: BBScriptCode): void {
    console.info('CHECK!!!!!!!');

    // Initialize BabylonJS Engine
    this.babylonjs.initEngine(this.canvas3d.nativeElement);

    // Create the scene.
    this.babylonjs.createScene();

    // Initialize 2D Service
    this.graphics2d.initCanvas(this.canvas2d.nativeElement);
    console.info('initCanvas executed');

    // Initialize GUI Service
    // TODO only if this would be necessary
    // this.gui.initCanvas(this.canvas3d.nativeElement);

    // console.info('Source code:', this.code);

    // initialize language service
    this.language.initialize().subscribe(() => {
      /*console.info(this.code[0].join(''));
      let lexerTokens: LexerToken[][] = this.lexer.lexCodeReactive(this.code);
      console.info('Lexer Tokens:', lexerTokens);

      //this.parser.parseCondition(lexerTokens[0]);

      let bbscriptCode: BBScriptCode = this.parser.createGameCode(lexerTokens);
      console.info('Target Code:', bbscriptCode);

      // Start render loop.
      this.babylonjs.mainLoop(bbscriptCode.mainLoop);

      //execute code lines
      this.executeCode(bbscriptCode);*/
    });

    if (this.debug) {
      // TODO different code execution with break points
    }

    console.info('Executing Code');

    // TODO handle main loop

    concat(...code.statements).subscribe(
      () => {
        console.info('Next statement has been executed.');
      },
      () => {
      },
      () => {
        console.info('### ALL CODE STATEMENTS EXECUTED ###');
      }
    );
  }
}
